const BUTTON_SIZE = "2.25rem"

export default function initScrollToTopButton() {
  const button = document.querySelector("#scrollToTopBtn")

  if (!button) {
    return
  }

  button.addEventListener("click", () => {
    window.scrollTo({ top: 0, behavior: "smooth" })
    button.style.opacity = 0
    setTimeout(
      () => button.style.display = "none",
      300
    )
    setTimeout(
      () => {
        button.style.opacity = 1
        button.style.display = "block"
      },
      1000
    )
  })

  window.addEventListener("scroll", () => {
    button.style.minWidth = window.scrollY >= 1000 ? BUTTON_SIZE : 0
  })
}